module.exports = __webpack_public_path__ + "img/2.4_Students-Trainees_5_Bullen.982d9574ef4f25a796bb415dfb8de0b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.4_Students-Trainees_5_Bullen.png
// module id = 770
// module chunks = 0